// Progress Bar Animation
document.addEventListener("DOMContentLoaded", function () {
    const progressBar = document.getElementById("progress-bar");

    if (!progressBar) return;

    let width = 0;
    const interval = setInterval(() => {
        if (width >= 80) {
            clearInterval(interval);
        } else {
            width += 10;
            progressBar.style.width = width + "%";
        }
    }, 100);

    window.addEventListener("load", () => {
        setTimeout(() => {
            progressBar.style.width = "100%";
            setTimeout(() => {
                progressBar.style.opacity = "0";
            }, 500);
        }, 200);
    });
});

// Scroll Direction Detection
let lastScrollTop = 0;
window.addEventListener('scroll', function () {
    const body = document.body;
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    if (currentScroll > lastScrollTop) {
        body.classList.add('scroll-down-body');
    } else {
        body.classList.remove('scroll-down-body');
    }
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
});
